import React, {
  createContext,
  useCallback,
  useEffect,
  useReducer,
  useState,
} from 'react';
import { GetParams } from '../../Helper';
import { PropertiesAdvanceSearchTest } from '../../Services';

export const CompletePropertyProfileContext = createContext({});
let nextHandler = null;
let saveHandler = null;
let validationHandler = null;
let navigationHandler = null;

function CompletePropertyProfileContextProvider({ children }) {
  const propertyId = +GetParams('id');
  const [isSaving, setIsSaving] = useState(false);
  const [currentStepId, setCurrentStepId] = useState(1);
  const [isFetched, setIsFetched] = useState(false);
  const [propertyInfo, setPropertyInfo] = useState(null);
  const [propertyImage, setPropertyImage] = useState(null);

  async function fetchPropertyInfo() {
    const body = {
      criteria: {
        Ids: [{ searchType: 1, value: propertyId }],
      },
      filterBy: 'createdOn',
      orderBy: 2,
    };
    try {
      const res = await PropertiesAdvanceSearchTest(
        { pageIndex: 0, pageSize: 25 },
        body
      );
      if (!(res && res.status && res.status !== 200)) {
        const dataBuffer = res?.result?.[0] || [];
        const temp1 = JSON.parse(dataBuffer?.propertyJson)?.property || {};
        setPropertyInfo(temp1);
        setPropertyImage(dataBuffer?.propertyImages?.[0] || null);
        setIsFetched(true);
      }
    } catch (error) {}
  }

  const setNextHandler = (fn) => {
    nextHandler = fn;
  };

  const callNextHandler = async (...args) => {
    if (typeof nextHandler === 'function') {
      setIsSaving(true);
      try {
        const result = await nextHandler(...args);
        return result;
      } finally {
        setIsSaving(false);
      }
    }
  };

  const setSaveHandler = (fn) => {
    saveHandler = fn;
  };

  const callSaveHandler = async (...args) => {
    if (typeof saveHandler === 'function') {
      setIsSaving(true);
      try {
        const result = await saveHandler(...args);
        return result;
      } catch (error) {
        return { success: false, error };
      } finally {
        setIsSaving(false);
      }
    }
    return { success: false };
  };

  const setValidationHandler = (fn) => {
    validationHandler = fn;
  };

  const callValidationHandler = (...args) => {
    if (typeof validationHandler === 'function') {
      return validationHandler(...args);
    }
    return true;
  };

  const setNavigationHandler = (fn) => {
    navigationHandler = fn;
  };

  const callNavigationHandler = async (...args) => {
    if (typeof navigationHandler === 'function') {
      return await navigationHandler(...args);
    }
  };

  const refetchPropertyInfo = async () => {
    setIsFetched(false);
    await fetchPropertyInfo();
  };

  useEffect(() => {
    if (propertyId && !isFetched) {
      fetchPropertyInfo();
    }
  }, [propertyId, isFetched]);

  const value = {
    setNextHandler,
    callNextHandler,
    setSaveHandler,
    callSaveHandler,
    setValidationHandler,
    callValidationHandler,
    setNavigationHandler,
    callNavigationHandler,
    isSaving,
    currentStepId,
    setCurrentStepId,
    propertyInfo,
    isFetched,
    propertyImage,
    refetchPropertyInfo,
  };

  return (
    <CompletePropertyProfileContext.Provider value={value}>
      {children}
    </CompletePropertyProfileContext.Provider>
  );
}

export default CompletePropertyProfileContextProvider;
